// eslint-disable-next-line
/* eslint-disable */
import { method } from 'lodash'
import { api } from './config'
import { relatorioService, apiIA } from './config'
import request from './request'

export default {
    medico: {

        retornarHelp(tipo) {
            return request({
                url: `/medico/retornarHelp/${tipo}`,
                method: 'get'
            })
        },

        verificarLocalAutomatico(idLocal) {
            var obj = {
                    idLocal: idLocal,
                }
                //return api.post('/medico/retornarPacientesDisponiveis/',obj);
            return request({
                url: `/medico/verificarLocalAutomatico/${idLocal}`,
                method: 'get',
            })
        },

        retornarConsultasPaciente(idAtendimento, idServico) {
            // console.log('idAtendimento: 44', idAtendimento, 'idServico', idServico);
            var obj = {
                    idAtendimento: idAtendimento,
                }
                //return api.post('/medico/retornarPacientesDisponiveis/',obj);
            return request({
                url: `/medico/retornarConsultasPaciente/${idAtendimento}/${idServico}`,
                method: 'get',
            })
        },

        retornarPacientesDisponiveis(listaServicos, primeiroAcesso, nomeLocal, tecnico, idMedico = null, idUnidade = null) {
            console.log('service retornar pacietes disp', listaServicos);

            var obj = {
                    servicos: listaServicos,
                    primeiroAcesso: primeiroAcesso,
                    nomeLocal: nomeLocal,
                    tecnico: tecnico,
                    idMedico: idMedico,
                    idUnidade: idUnidade
                }
                //return api.post('/medico/retornarPacientesDisponiveis/',obj);
            return request({
                url: '/medico/retornarPacientesDisponiveis/',
                method: 'post',
                data: obj
            })
        },
        retornarPacientesDisponiveis2(listaServicos, primeiroAcesso, nomeLocal, tecnico, idMedico = null, idUnidade = null) {
            console.log('service retornar pacietes disp', listaServicos);

            var obj = {
                    servicos: listaServicos,
                    primeiroAcesso: primeiroAcesso,
                    nomeLocal: nomeLocal,
                    tecnico: tecnico,
                    idMedico: idMedico,
                    idUnidade: idUnidade
                }
                //return api.post('/medico/retornarPacientesDisponiveis/',obj);
            return request({
                url: '/medico/retornarPacientesDisponiveis2/',
                method: 'post',
                data: obj
            })
        },

        liberarPacientes(idAtendimentos) {;

            var obj = {
                    idAtendimentos: idAtendimentos,
                }
                //return api.post('/medico/retornarPacientesDisponiveis/',obj);
            return request({
                url: '/medico/liberarPacientes/',
                method: 'post',
                data: obj
            })
        },

        retornarServicosDoMedico(idMedico = 0) {
            const urlMedico = `/medico/retornarServicosdoMedicoAntigo?idMedico=${idMedico}`
            console.log('urlMedico: ', urlMedico);
            
            return request({
                url: urlMedico,
                method: 'get'
            }).catch(err => {
                
                return Promise.reject(err)
            })
        },

        retornarConsultasFinalizadas(idMedico, idUnidade) {
            return request({
                url: `/medico/retornarConsultasFinalizadas?idMedico=${idMedico}&idUnidade=${idUnidade}`,
                method: 'get'
            })
        },

        retornarMedicamentos (nome) {
            console.log(nome);
            return request({
                url: `/medico/retornarMedicamentos/${nome}`,
                method: 'get'
            })
        },

        cadastrarProntuario (data) {
            return request({
                url: '/medico/cadastrarProntuario',
                method: 'post',
                data: data
            })
        },

        cadastrarRelatorio (data) {
            console.log(data);
            
            return request({
                url: '/medico/cadastrarRelatorio',
                method: 'post',
                data: data
            })
        },
        atualizarRelatorio (data) {
            console.log(data);
            return request({
                url: '/medico/atualizarRelatorio',
                method: 'put',
                data: data
            })
        },

        buscarRelatorioPorId (id) {
            return request({
                url: `/medico/buscarRelatorioPorId?id=${id}`,
                method: 'get'
            })
        },
        buscarRelatoriosAtendimento (idAtendimento) {
            return request({
                url: `/medico/buscarRelatoriosAtendimento?idAtendimento=${idAtendimento}`,
                method: 'get'
            })
        },
        removerRelatorio (id) {
            return request({
                url: `/medico/removerRelatorio?id=${id}`,
                method: 'delete'
            })
        },
        retornarTipoHorarioPrescricao () {
            return request({
                url: `/medico/retornarTipoHorarioPrescricao`,
                method: 'get'
            })
        },

        cadastrarPosologia (data) {
            console.log(data);
            return request({
                url:'/medicamento/cadastrarPosologia',
                method: 'post',
                data :data
            })
        },

        retornarPosologia (idUsuario, idMedicamento) {
            return request({
                url:`/medicamento/buscarPosologia/?idUsuario=${idUsuario}&idMedicamento=${idMedicamento}`,
                method: 'get'
            })
        },

        /** 
         * Cadastrar nova receita médica
         * @param {Object} data - Dados da receita {idConsulta, descricao}
         * @returns {Promise}
         */
        cadastrarReceitaMedica(data) {
            return request({
                url: '/medico/cadastrarReceitaMedica',
                method: 'post',
                data: data
            })
        },

        /**
         * Atualizar receita médica existente
         * @param {Object} data - Dados atualizados {idReceitaMedica, descricao}
         * @returns {Promise}
         */
        atualizarReceitaMedica(data) {
            return request({
                url: '/medico/atualizarReceitaMedica',
                method: 'post',
                data: data
            })
        },

        /**
         * Listar receitas médicas por ID de atendimento e ID de médico
         * @param {Number} idAtendimento - ID do  atendimento
         * @param {Number} idMedico - ID do médico
         * @returns {Promise}
         */
        listarReceitaMedica(idAtendimento, idMedico) {
            console.log(idAtendimento, idMedico);
            
            return request({
                url: `/medico/listarReceitaMedicaPorIdAtendimentoIdMedico?idAtendimento=${idAtendimento}&idMedico=${idMedico}`,
                method: 'get'
            })
        },

        /**
         * Remover receita médica pelo ID
         * @param {Number} idReceitaMedica - ID da receita a ser removida
         * @returns {Promise}
         */
        deleteReceitaById(idReceitaMedica) {
            console.log(idReceitaMedica)
            return request({
                url: '/medico/deleteReceitaById?idReceitaMedica=' + idReceitaMedica,
                method: 'delete'
            })
        },

        listarExamesPorNome (nome, sadt) {            
            return request({
                url: `medico/buscarExamePorNome?nome=${nome}&sadt=${sadt}`,
                method: 'get'
            })
        },
        listarExamesPorEspecialidade (idEspecialidade) {
            console.log('chegou aqui: ', idEspecialidade);
            
            return request({
                url: `medico/listarExamesPorEspecialidade?idEspecialidade=${idEspecialidade}`,
                method: 'get'
            })
        },
        cadastrarSolicitacaoExame (data) {
            return request({
                url: `medicamento/cadastrarSolicitacaoExame`,
                method: 'post',
                data
            })
        },
        listarSolicitacoesExames (idUsuario) {
            return request({
                url: `medicamento/listarSolicitacoesExames/${idUsuario}`,
                method: 'get'
            })
        },
        cadastrarAvaliacaoPsicosocial (data) {
            return request({
                url: `medico/cadastrarAvaliacaoPsicosocial`,
                method: 'post',
                data
            })
        },
        buscarAvaliacaoPsicosocial (idExamesOs) {
            return request({
                url: `medico/buscarAvaliacaoPsicosocial?idExamesOs=${idExamesOs}`,
                method: 'get'
            })
        },
        buscarPacoteExames (idUsuario, sadt, idUnidade) {
            console.log(`medicamento/buscarPacoteExames?idUsuario=${idUsuario}&sadt=${sadt}&idUnidade=${idUnidade}`)
            return request({
                url: `medicamento/buscarPacoteExames?idUsuario=${idUsuario}&sadt=${sadt}&idUnidade=${idUnidade}`,
                method: 'get'
            })
        },
        cadastrarModeloProntuario (idUsuario, titulo, descricao, tipo, idModelo, idExame, nomeExame) {
            const data = {
                idUsuario: idUsuario,
                titulo: titulo,
                descricao: descricao,
                tipo: tipo,
                idModelo: idModelo,
                idExame: idExame,
                nomeExame: nomeExame
            }
            return request({
                url: `medico/cadastrarModeloProntuario`,
                method: 'post',
                data
            })
        },
        listarModelosProntuario (tipo, idUsuario, idExame) {            
            return request({
                url: `medico/listarModelosProntuario?tipo=${tipo}&idUsuario=${idUsuario}&idExame=${idExame}`,
                method: 'get'
            })
        },

        retornarLocais(idUnidade) {
            return request({
                url: 'medico/retornarLocais/'+idUnidade,
                method: 'get'
            })
        },

        fazerChamada(idAtendimento, codigo, nomeConsultorio, idConsulta, nomeMedico,
            nomePaciente, prioridade, idLocalMedico, nomeLocal, tecnico, automatico, idLocal,
            idPaciente, dataNascimento) {
            var obj = {
                    codigo: codigo,
                    idAtendimento: idAtendimento,
                    nomeConsultorio: nomeConsultorio,
                    idConsulta: idConsulta,
                    nomeMedico: nomeMedico,
                    nomePaciente: nomePaciente,
                    prioridade: prioridade,
                    idLocalMedico: idLocalMedico == 8 ? '8,9' : idLocalMedico == 9 ? '8,9' : idLocalMedico,
                    nomeLocal: nomeLocal,
                    tecnico: tecnico,
                    automatico: automatico,
                    idLocal: idLocal,
                    idPaciente: idPaciente,
                    dataNascimento: dataNascimento
                }
                console.log('obj', obj);
                
                //return api.post('/medico/fazerChamada',obj)
            return request({
                url: '/medico/fazerChamada/',
                method: 'post',
                data: obj
            })

        },

        iniciarAtendimento(idAtendimento, codigo, idConsulta) {
            console.log('em servico');
            var obj = {
                    codigo: codigo,
                    idAtendimento: idAtendimento,
                    idConsulta: idConsulta
                }
                //return api.post('/medico/iniciarAtendimento',obj) 
            return request({
                url: '/medico/iniciarAtendimento/',
                method: 'post',
                data: obj
            })
        },

        atualizaPrestadorServico(idUsuario, idOs, codigo) {
            var obj = {
                idUsuario: idUsuario,
                idOs: idOs,
                codigo: codigo
            }

            return request({
                url: '/medico/atualizaPrestadorServico/',
                method: 'post',
                data: obj
            })
        },

        encerrarAtendimento(idMedico, idUnidade, idAtendimento, idConsulta, consultas, dataChegada, nomeConsultorio, isMedico, idExamesos, idOrdemServico) {
            var obj = {
                    idMedico: idMedico,
                    idUnidade: idUnidade,
                    idAtendimento: idAtendimento,
                    idConsulta: idConsulta,
                    consultas: consultas,
                    dataChegada: dataChegada,
                    nomeConsultorio: nomeConsultorio,
                    isMedico: isMedico,
                    idExamesos: idExamesos,
                    idOrdemServico: idOrdemServico
                }
                console.log('------>', obj.idOrdemServico)
                //return api.post('/medico/encerrarAtendimento',obj)
            return request({
                url: '/medico/encerrarAtendimento/',
                method: 'post',
                data: obj
            })
        },

        offline(idMedico) {
            var obj = {
                idMedico: idMedico,
            }
            return api.post('/medico/offline/', obj)
        },

        chamadaNaoAtendida(idAtendimento) {
            console.log('em servico');
            var obj = {
                    idAtendimento: idAtendimento
                }
                //return api.post('/medico/chamadaNaoAtendida',obj)
            return request({
                url: '/medico/chamadaNaoAtendida/',
                method: 'post',
                data: obj
            })
        },

        retornarExamesPorId (data) {
            const obj = { idsExames: data }
            return request({
                url: `medico/retornarExamesPorId`,
                method: 'post',
                data: obj
            })
        },

        disponibilizarServicos(servicos, nome, primeiroAcesso, nomeLocal, nomeConsultorio, tecnico) {

            console.log('em add servicos servicos', nomeLocal, nomeConsultorio);

            var obj = {
                servicos: servicos,
                nomeMedico: nome,
                primeiroAcesso: primeiroAcesso,
                nomeLocal: nomeLocal,
                nomeConsultorio: nomeConsultorio,
                tecnico: tecnico
            }

            //return api.post('/medico/adicionarServicos',obj)
            return request({
                url: '/medico/disponibilizarServicos/',
                method: 'post',
                data: obj
            })
        },
        atendimentoEmEspera(idAtendimento) {

            var obj = {
                    idAtendimento: idAtendimento
                }
                //return api.post('/medico/adicionarServicos',obj)
            return request({
                url: '/medico/atendimentoEmEspera/',
                method: 'post',
                data: obj
            })
        },
        refreshToken(token, idLocal, idUnidade) {
            // metodo do visor..  
            //return api.post('/atendente/retornarChamadas',obj)
            var obj = {
                idLocal: idLocal,
                idUnidade: idUnidade,
                token: token,
            }
            return request({
                url: '/medico/refreshToken',
                method: 'post',
                data: obj
            })
        },
        retornarInfoPacienteOs(os) {            
            return request({
                url: `/simplesMedic/retornarInfoPaciente/${os}`,
                method: 'get'
            })
        },

        cadastrarLaudoClinico(data) {
            console.log('data', data);
            return request({
                url: `/simplesMedic/cadastrarLaudoClinico`,
                method: 'POST',
                data: data
            })
        },

        editarLaudoClinico(idExamesOs, descricao, status) {
           console.log('editarLaudoClinico', idExamesOs, descricao, status);
           
            
            return request({
                url: `/simplesMedic/editarLaudoClinico`,
                method: 'POST',
                data: {
                    idExamesOs: idExamesOs, 
                    descricao: descricao,
                    status: status
                }
            })
        },
        buscarLaudoClinicoPorIdExamesOS (idExamesOs) {
            
            return request({
                url: `/simplesMedic/buscarLaudoClinicoPorIdExamesOS?idExamesOs=${idExamesOs}`,
                method: 'GET'
            })
        },
        cadastrarAnamneseText(data) {
            return request({
                url: `/simplesMedic/cadastrarAnamneseText`,
                method: 'POST',
                data: data
            })
        },
        buscarAnamneseTextPorIdExamesos(idExamesos) {
            return request({
                url: `/simplesMedic/buscarAnamneseTextPorIdExamesos?idExamesos=${idExamesos}`,
                method: 'GET'
            })
        },
        editarAnamneseText(data) {
            return request({
                url: `/simplesMedic/editarAnamneseText`,
                method: 'POST',
                data: data
            })
        },
        apagarAnamneseText(id) {
            return request({
                url: `/simplesMedic/apagarAnamneseText`,
                method: 'POST',
                data: {
                    id: id
                }
            })
        },
         buscarLaudoComStatus (idExamesOs) {
            return request({
                url: `/simplesMedic/buscarLaudoComStatus?idExamesOs=${idExamesOs}`,
                method: 'GET'
            })
        },
        
        buscarProntuarioPorIdExamesOS (idExamesOs) {

            return request({
                url: `/simplesMedic/buscarProntuarioPorIdExamesOS?idExamesOs=${idExamesOs}`,
                method: 'GET'
            })
        },
        dowloadProntuario(idPaciente) {
            return request({
                url: `/medico/downloadProntuario/${idPaciente}`,
                method: 'get',
                responseType: 'blob'
            })
        },

        downloadLaudo(idExamesOS) {
            return request({
                url: `/medico/downloadLaudo?idexamesos=${idExamesOS}`,
                method: 'get',
                responseType: 'blob'
            })
        },

        retornarInfoOsPorData(idPaciente) {
            return request({
                url: `/simplesMedic/retornarInfoOsPorData?idPaciente=${idPaciente}`,
                method: 'get'
            })
        },
        retornarConsultasOs(os){
            return request({
                url: `/medico/retornarConsultasOs/${os}`,
                method: 'get'
            })
        },
        retornarProntuario (idConsulta) {
            //console.log(idConsulta)
                return request({
                url: `/medico/retornarProntuario/${idConsulta}`,
                methods: 'get'
            })
        },
        downloadRelatorioReceita: (data) => {
            console.log(data)
            
            return relatorioService.post('Relatorio/rest/atendimento/receita', data, {
                responseType: 'blob'
              })
          },
          downloadRelatorioLaudo: (data) => {
            return relatorioService.post('Relatorio/rest/atendimento/laudo', data, {
                responseType: 'blob'
              })
          },
        cadastrarExameMedicoSolicitacao: (data) => {
            return request({
                url: 'medico/cadastrarExameMedicoSolicitacao',
                method: 'POST',
                data: data
            })
          },
        cadastrarAnamnese: (data)  => {
            return request({
                url: 'medicamento/cadastrarAnamnese',
                method: 'POST',
                data: data
            })
        },
        buscarAnamnese: (idAtendimento) => {
            return request({
                url: `medicamento/buscarAnamnese/${idAtendimento}`,
                method: 'GET',
            })
        },
        retornarMetricasDeAtendimentoMensaisAnuais: (idMedico) => {
            return request({
                url: `medico/retornarMetricasDeAtendimentoMensaisAnuais?idMedico=${idMedico}`,
                method: 'GET',
            })
        },
        retornarMetricasDeAtendimento: (idMedico,data1, data2) => {
            return request({
                url: `medico/retornarMetricasDeAtendimento?idMedico=${idMedico}&date1=${data1}&date2=${data2}`,
                method: 'GET',
            })
        },
        buscarPacientesMedicosConsultasPorData: (data) => {
            console.log(data)
            return request({
                url: `medico/buscarPacientesMedicosConsultasPorData?date=${data}`,
                method: 'GET',
            })
        },
        buscarPacientesConsultasPorData: (idMedico, data) => {
            console.log(data)
            return request({
                url: `medico/buscarPacientesConsultasPorData?idMedico=${idMedico}&date=${data}`,
                method: 'GET',
            })
        },

        buscarPacienteAtendimentoPorNome: (nome, idUnidade) => {
            console.log(nome)
            return request({
                url: `medico/buscarPacienteAtendimentoPorNome?nome=${nome}&idUnidade=${idUnidade}`,
                method: 'GET',
            })
        },
        buscarConultasPorAtendimento: (idAtendimento) => {
            console.log(idAtendimento)
            return request({
                url: `medico/buscarConultasPorAtendimento?idAtendimento=${idAtendimento}`,
                method: 'GET',
            })
        },
        buscarQuantidadeDeAtendimentosPorStatus: (idMedico) => {
            console.log(data)
            return request({
                url: `medico/quantidadeDeAtendimentosPorStatus?idMedico=${idMedico}`,
                method: 'GET',
            })
        },
        cadastrarPacoteExames: (medicos, idPacote) => {
            var data = {
              medicos: medicos,
              idPacote: idPacote
            }
            console.log(data)
            return request({
                url: 'medicamento/cadastrarPacoteExames',
                method: 'POST',
                data: data
            })
        },
        buscarQtdProntuariosPaciente (idPaciente, idMedico, data, idExameEspecialidade) {
            // console.log('------=-----', idPaciente, idMedico, data, idExameEspecialidade)
            return request({
                url: `medico/qtdProntuariosPaciente?idPaciente=${idPaciente}&idMedico=${idMedico}&data=${data}&idExameEspecialidade=${idExameEspecialidade}`,
                method: 'GET',
            })
        },
        retornarProntuariosPaciente (idPaciente, limit, offset, idMedico, data, idExameEspecialidade) {
           console.log('==-', `medico/retornarProntuariosPaciente?idPaciente=${idPaciente}&limit=${limit}&offset=${offset}&idMedico=${idMedico}&data=${data}&idExameEspecialidade=${idExameEspecialidade}`);
            return request({
                url: `medico/retornarProntuariosPaciente?idPaciente=${idPaciente}&limit=${limit}&offset=${offset}&idMedico=${idMedico}&data=${data}&idExameEspecialidade=${idExameEspecialidade}`,
                method: 'GET',
            })
        },
        retornarProntuarioPorId (idProntuario) {
             return request({
                 url: `medico/retornarProntuarioPorId?idProntuario=${idProntuario}`,
                 method: 'GET',
             })
         },
        retornarEspecialidades () {
            return request({
                url: `medico/retornarEspecialidades`,
                method: 'GET',
            })
        },
        retornarClientesPorNome (nome) {
            return request({
                url: `simplesMedic/retornarClientesPorNome?nome=${nome}`,
                method: 'GET',
            })
        },
        filtrarPacientesPorNome (nome) {
            return request({
                url: `simplesMedic/filtrarPacientesPorNome?nome=${nome}`,
                method: 'GET',
            })
        },
        filtrarPacientesPorCpf (cpf) {
            return request({
                url: `simplesMedic/filtrarPacientesPorCpf?cpf=${cpf}`,
                method: 'GET',
            })
        },
        cadastrarPacienteSimples (nome, cpf, celular, dataNascimento, sexo) {
            var data = {
                nome: nome,
                cpf: cpf,
                celular: celular,
                dataNascimento: dataNascimento,
                sexo: sexo
             }
             console.log(data)
            return request({
                url: 'simplesMedic/cadastrarPacienteSimples',
                method: 'POST',
                data: data 
            })
        },
        retornarMetricasMedico(id_unidade) {
            return request({
                url: `medico/retornarTempoMedioConsulta?idUnidade=${id_unidade}`,
                method: 'GET',
            })
           
        },
        retornarTop5 (id_unidade) {
            return request({
                url: `medico/retornarTopFiveMedicos?idUnidade=${id_unidade}&ano=2024&mes=2`,
                method: 'GET',
            })
        },
        editarProntuario (data) {
            console.log(data);
            return request({
                url: 'medico/editarProntuario',
                method: 'POST',
                data: data
            })
        },
        editarLaudo (data) {
            console.log(data);
            return request({
                url: 'medico/editarLaudo',
                method: 'POST',
                data: data
            })
        },
        alterarSenha (data) {
            console.log(data);
            return request({
                url: 'medico/alterarSenhaMedico',
                method: 'POST',
                data: data
            })
        },
        retornarInformacoesPacienteOs (os) {
            return request({
                url: `simplesMedic/retornarInformacoesPacienteOs?os=${os}`,
                methods: 'get'
            })
        },
        listarProntuariosSimples (os, idPrestador) {
            return request({
                url: `simplesMedic/listarProntuarios?os=${os}&idPrestador=${idPrestador}`,
                method: 'get'
            })
        },
         listarLaudosSimples (os, idPrestador) {
            return request({
                url: `simplesMedic/listarLaudos?os=${os}&idPrestador=${idPrestador}`,
                method: 'get'
            })
        },
        retornarResumoProntuario (idConsulta) {
            console.log('idConsulta', idConsulta);
            
            return request({
                url: `medico/retornarResumoProntuario?idConsulta=${idConsulta}`,
                method: 'get'
            })
        },
        retornarUltimoProntuarioOS (os) {
            return request({
                url: `simplesMedic/retornarUltimoProntuarioOS?os=${os}`,
                method: 'get'
            })
        },
        retornarProntuarioSimplesPorId (idProntuario) {
            return ({
                url: `simplesMedic/retornarProntuarioPorId?idProntuario=${idProntuario}`,
                method: 'get'
            })
        },
        metricasAtendimento (idMedico, idUnidade) {            
            return request({
                url: `medico/metricasAtendimento?idMedico=${idMedico}&idUnidade=${idUnidade}`,
                method: 'get'
            })
        },
        cadastrarCredenciaisAtendimento (data) {
            console.log('credenciais: ', data);
            
            return request({
                url: `medico/cadastrarCredenciaisAtendimento`,
                method: 'POST',
                data: data
            })
        },
        listarCredenciaisAtendimento (idUsuario) {
            return request({
                url: `medico/listarCredenciaisAtendimento?idUsuario=${idUsuario}`,
                method: 'GET'
            })
        },
        cadastrarLaudoTec(data) {              
            console.log('cados cadastro: ', data);
            
            return request({
                url: `/simplesMedic/cadastrarLaudoTec`, 
                headers: {
                    'Content-Type': 'multipart/form-data'
                },            
                method: 'POST',           
                data: data
            })
        },
        cadastrarFichaExamesOS(data) {              
            return request({
                url: `/simplesMedic/cadastrarFichaExamesOS`,             
                method: 'POST',           
                data: data
            })
        },
        removerCredenciaisAtendimento (id) {
            return request({
                url: `medico/removerCredenciaisAtendimento?id=${id}`,
                method: 'GET'
            })
        },
        listarEquipeMedica (idUnidade) {
            return request ({
                url: `medico/listarEquipeMedica?idUnidade=${idUnidade}`,
                method: 'GET'
            })
        },
        listarLaudosTec (idPrestador, status) {
            return request({
                url: `simplesmedic/listarLaudosTec?idPrestador=${idPrestador}&status=${status}`,
                method: 'GET'
            })
        },
        listarLaudosTecByIdsExamesOs(idsExamesOs) {
            const ids = idsExamesOs.join(',');
            console.log('ids service: '+ ids)
            return request({
                url: `simplesmedic/listarLaudosTecByIdsExamesOs/${ids}`, 
                method: 'GET'
            });
        },  
        listarLaudosTecByIdsExamesOsTec(queryString) {     
            
            return request({
                url: `simplesmedic/listarLaudosTecByIdsExamesOsTec?${queryString}`, 
                method: 'GET',
                
            });
        },        
        quantidadeLaudosTec (idMedico) {
            return request({
                url: `simplesmedic/quantidadeLaudosTec?idMedico=${idMedico}`,
                method: 'GET'
            })
        },
        buscarFichaExamesOS (idExamesOS) {
            return request({
                url: `simplesmedic/buscarFichaExamesOS?idExamesOS=${idExamesOS}`,
                method: 'GET'
            })
        },
        cadastrarModeloReceituario (data) {
            return request({
                url: `medico/cadastrarModeloReceituario`,
                method: 'POST',
                data: data
            })
        },
        buscarModelosReceituario (idMedico) {
            
            return request({
                url: `medico/buscarModelosReceituario?idMedico=${idMedico}`,
                method: 'GET'
            })
        },
        cadastrarModeloProntuarioAtendimento (data) {
            return request({
                url: `medico/cadastrarModeloProntuarioAtendimento`,
                method: 'POST',
                data: data
            })
        },
        buscarModeloProntuarioAtendimento (idMedico) {
            return request({
                url: `medico/buscarModeloProntuarioAtendimento?idMedico=${idMedico}`,
                method: 'GET'
            })
        },
        cadastrarModeloLaudo (data) {
            return request({
                url: `medico/cadastrarModeloLaudo`,
                method: 'POST',
                data: data
            })
        },
        buscarModeloLaudo (idMedico) {
            return request({
                url: `medico/buscarModeloLaudo?idMedico=${idMedico}`,
                method: 'GET'
            })
        },
         cadastrarModeloRelatorio (data) {
            return request({
                url: `medico/cadastrarModeloRelatorio`,
                method: 'POST',
                data: data
            })
        },
        buscarModeloRelatorio (idMedico) {
            return request({
                url: `medico/buscarModeloRelatorio?idMedico=${idMedico}`,
                method: 'GET'
            })
        },
        consultarResumoClinico (idPaciente, idMedico) {
                return apiIA.get(`/api/resumomedico/${idPaciente}/${idMedico}`)
            },

        finalizarApi (idUsuario, exames) {
                return apiIA.post(`/api/finalizarAtendimento`, {
                    idUsuario: idUsuario,
                    examesos_ids: exames
                })
            },
        retornarListaConsultas (idPaciente) {
            return apiIA.get(`/api/laudos/${idPaciente}`)
        },
        
        resumomedico (idPaciente, idMedico) {
            return apiIA.get(`/api/resumomedico/${idPaciente}/${idMedico}`)
        }
    }
}
